import { useCallback } from 'react';
import { withPreventDefault } from '../lib/events';

export function useSubmitHandler(func, deps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(withPreventDefault(func), deps || [func]);
}
